var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8288 8.30603L11.9188 11.4541C11.1788 12.0342 10.1416 12.0342 9.40162 11.4541L5.45807 8.30603",
    stroke: "#6638A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31389 3.20831H14.9562C16.2023 3.22229 17.3883 3.74908 18.238 4.666C19.0877 5.58292 19.527 6.80992 19.4535 8.06125V14.0451C19.527 15.2965 19.0877 16.5235 18.238 17.4404C17.3883 18.3573 16.2023 18.8841 14.9562 18.8981H6.31389C3.63731 18.8981 1.83334 16.7206 1.83334 14.0451V8.06125C1.83334 5.38581 3.63731 3.20831 6.31389 3.20831Z",
    stroke: "#6638A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a4314572d7e063f0f1ec6820255f146d.svg";
export { ForwardRef as ReactComponent };